'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'strawberry';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e32b';
var svgPathData = 'M397.1-12.7c6.2-6.2 16.4-6.2 22.6 0L431.8-.6c31.2 31.2 31.2 81.9 0 113.1 31.2-31.2 81.9-31.2 113.1 0l12.1 12.1c6.2 6.2 6.2 16.4 0 22.6l-12.1 12.1c-31.2 31.2-81.9 31.2-113.1 0-15.6-15.6-31.2-31.2-46.9-46.9-31.2-31.2-31.2-81.9 0-113.1l12.1-12.1zM32.4 336c0-176 96.2-272 192.2-272 32.7 .1 65.3 12.6 90.3 37.5l128 128c25 25 37.5 57.8 37.5 90.5 0 96-96 192-272 192-128 0-176-48-176-176zM205.2 172.8c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm-32 96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm87.3 2.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm32-96c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7zm72.7 29.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zm-224-96c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7 14.6-28.3 8.7-34.3zM141.2 364.8c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7-14.6 28.3-8.7 34.3 22.4 3.2 34.3-8.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStrawberry = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;